module.exports = __webpack_public_path__ + "img/HHcfeladatlap2025.68689c5f.jpg";